import { render, staticRenderFns } from "./groups-side-bar.vue?vue&type=template&id=70b7a20a&scoped=true&"
import script from "./groups-side-bar.vue?vue&type=script&lang=js&"
export * from "./groups-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./groups-side-bar.vue?vue&type=style&index=0&id=70b7a20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7a20a",
  null
  
)

export default component.exports